import axios from 'axios'
import { baseURL } from './config'
import { getState } from '../store/store'
import { isString } from 'lodash'


export const api = ({ method, url, body, headers, transformRequest }) => {
    const regex = /{[^\/]*}/g;
    var m;
    if (body && isString(body))
        body = JSON.parse(JSON.stringify(body));
    while ((m = url.match(regex)) !== null) {
        var urlParamName = m[0].substring(1, m[0].length - 1);
        url = url.replace(m[0], body[urlParamName]);
        delete body[urlParamName];
    }
    if (!headers){
        headers = {
            'X-Request-Token': getState('shared').token
        };
    } else {
        headers[ 'X-Request-Token'] = getState('shared').token
    }
    if (method === 'GET' && body != null) {
        let keys = [];
        Object.keys(body).forEach(item => {
            if (Array.isArray(body[item])) {
                body[item].forEach(element => keys.push(item + "=" + encodeURIComponent(element)))
            } else if (body[item] instanceof Date) {
                keys.push(item + "=" + encodeURIComponent(body[item].toISOString()));
            } else {
                keys.push(item + "=" + encodeURIComponent(body[item]));
            }
        })
        if (Object.keys(body).length !== 0) {
            url += ("?" + keys.join("&"));
        }
    } else {
        body = body;
    }
    return axios({
        method: method,
        baseURL: baseURL,
        url: url,
        headers: headers,
        data: body,
        transformRequest: transformRequest
    })
}